import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify'
import cookie from 'react-cookies'

export const FETCH_COMPONENT_NOT_CHILDREN = 'FETCH_COMPONENT_NOT_CHILDREN '
export const RECEIVE_COMPONENT_NOT_CHILDREN = 'RECEIVE_COMPONENT_NOT_CHILDREN'
export const FAILED_COMPONENT_NOT_CHILDREN = 'FAILED_COMPONENT_NOT_CHILDREN'

export function fetchComponentNotChildren(_data){
    return (dispatch, getState) => {
        dispatch({type: FETCH_COMPONENT_NOT_CHILDREN})
        axios({
            method: 'POST',
            url: API_LINKS.COMPONENT_NOT_CHILDREN,
            headers: {
                Authorization: cookie.load('token')
            },
            data: _data
        })
        .then((response) => {
            if(response.status === 200){
                if(response.data.status === "success"){
                    dispatch({
                        type: RECEIVE_COMPONENT_NOT_CHILDREN,
                        payload: response.data.result
                    })
                } else {
                    dispatch({
                        type: FAILED_COMPONENT_NOT_CHILDREN
                    })
                }
            } else {
                dispatch({
                    type: FAILED_COMPONENT_NOT_CHILDREN
                })
            }
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_COMPONENT_NOT_CHILDREN
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 403) {
                    dispatch({
                        type: FAILED_COMPONENT_NOT_CHILDREN
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_COMPONENT_NOT_CHILDREN
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_COMPONENT_NOT_CHILDREN
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else {
                    dispatch({
                        type: FAILED_COMPONENT_NOT_CHILDREN
                    })
                    return toast.error('Something went wrong... Please try again later...')
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_COMPONENT_NOT_CHILDREN
                })
                return toast.error('Request have no response! Please check on your internet connection and refresh this page.')
            } else {
                dispatch({
                    type: FAILED_COMPONENT_NOT_CHILDREN
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/components/aComponent-NotChildrenList.jsx